<!-- Header -->
<div class="flex items-center justify-between p-6 border-b border-gray-200">
  <h2 class="text-2xl font-bold text-gray-900">Topex Report</h2>
  <button
    type="button"
    class="text-gray-400 hover:text-gray-600 transition-colors duration-200"
    [mat-dialog-close]="false"
  >
    <i class="fas fa-times text-xl"></i>
  </button>
</div>

<!-- Content -->
<div class="p-6 max-h-[70vh] overflow-y-auto">
  <!-- Tabs Navigation -->
  <div class="border-b border-gray-200 mb-6">
    <nav class="-mb-px flex space-x-8">
      @for (report of topexReports; track report; let i = $index) {
        <button
          class="py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200"
          [ngClass]= "{'border-blue-500 text-blue-600': activeTab === i,
          'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300' : activeTab !== i}"
          (click)="activeTab = i">
          <i class="fas mr-2" [class]="i === 0 ? 'fa-house-damage' : 'fa-vector-square'"></i>
          {{ report.target.name }}
        </button>
      }
    </nav>
  </div>

  <!-- Tab Content -->
  <div *ngFor="let report of topexReports; let i = index" [class.hidden]="activeTab !== i">
    <!-- Report Header -->
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 mb-6">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ report.target.name }}</h3>
          <p class="text-sm text-gray-600">
            <i class="fas fa-map-marked-alt mr-2"></i>
            Reporting Area: <span class="font-medium">{{ report.target.area | round:1 }} hectares</span>
          </p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3">
          <button
            (click)="viewOnMap(report.target)"
            class="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
          >
            <i class="fas fa-map mr-2"></i>
            View on Map
          </button>
          <button
            (click)="export(report)"
            class="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors duration-200"
          >
            <i class="fas fa-download mr-2"></i>
            Export PDF
          </button>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Topex Score
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Exposure Description
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Area (ha)
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                % of Reporting Area
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let element of report.data" class="hover:bg-gray-50 transition-colors duration-150">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ element.topexScore }}
              </td>
              <td class="px-6 py-4 text-sm text-gray-900">
                {{ element.exposureDescription }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {{ element.area | round:1 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {{ element.percentage | round:1 }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="flex justify-end p-6 border-t border-gray-200 bg-gray-50">
  <button
    type="button"
    class="px-6 py-2 bg-gray-600 text-white text-sm font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
    [mat-dialog-close]="false"
  >
    Close
  </button>
</div>
